import { AxiosInstance } from 'axios';
import { BulkEndpoint } from './BulkServices.types';

import {
  BulkJobServices,
  BulkJobServicesEndpoint,
  BulkOrderServicesEndpoint,
  BulkOrderServices,
} from './services';

export class BulkSevices implements BulkEndpoint {
  instance: AxiosInstance;
  job: BulkJobServicesEndpoint;
  order: BulkOrderServicesEndpoint;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.job = new BulkJobServices(instance);
    this.order = new BulkOrderServices(instance);
  }
}
